import { render, staticRenderFns } from "./InventoryAttributeView.vue?vue&type=template&id=799062e7&scoped=true"
import script from "./InventoryAttributeView.vue?vue&type=script&lang=js"
export * from "./InventoryAttributeView.vue?vue&type=script&lang=js"
import "./InventoryAttributeView.vue?vue&type=style&index=0&id=799062e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799062e7",
  null
  
)

export default component.exports